import { __awaiter } from "tslib";
import { isNil } from 'ramda';
import { CommonFeatureFlagsService } from '../common-feature-flags-service';
export class InternalFeatureFlagsService extends CommonFeatureFlagsService {
    constructor({ sessionStoragePrefix = '' }) {
        super();
        this.prefix = sessionStoragePrefix;
    }
    getFeatureFlagValueFromCache(flag) {
        const value = this.featureFlagCache[flag];
        return typeof value === 'boolean' ? value : null;
    }
    getValueFromStorage(flag) {
        const featureFlag = window.sessionStorage.getItem(`${this.prefix}${flag}`);
        if (!isNil(featureFlag)) {
            // Try to parse as JSON first (for object configs)
            try {
                const parsed = JSON.parse(featureFlag);
                this.featureFlagCache[flag] = parsed;
                return parsed;
            }
            catch (_a) {
                // If JSON parsing fails, treat as boolean string
                const featureFlagValue = featureFlag === 'true';
                this.featureFlagCache[flag] = featureFlagValue;
                return featureFlagValue;
            }
        }
        return null;
    }
    getFeatureFlagValueFromStorage(flag) {
        const value = this.getValueFromStorage(flag);
        return typeof value === 'boolean' ? value : null;
    }
    updateCacheWithNewFeatureFlags(flags) {
        const cache = this.generateFeatureFlagCache(flags);
        this.featureFlagCache = Object.assign(Object.assign({}, this.featureFlagCache), cache);
    }
    generateFeatureFlagCache(featureFlags) {
        return featureFlags.reduce((flagCache, flag) => {
            const featureFlagValue = this.getValueFromStorage(flag);
            if (!isNil(featureFlagValue) || this.persistedFlags.has(flag)) {
                flagCache[flag] = featureFlagValue;
            }
            return flagCache;
        }, {});
    }
    clearFeatureFlagsFromSessionStorage() {
        this.featureFlags.forEach((flag) => {
            if (!this.persistedFlags.has(flag)) {
                window.sessionStorage.removeItem(`${this.prefix}${flag}`);
            }
        });
    }
    saveFeatureFlags(features) {
        Object.keys(features).forEach((feature) => {
            try {
                const value = features[feature];
                const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
                window.sessionStorage.setItem(`${this.prefix}${feature}`, stringValue);
            }
            catch (error) {
                // options parameter was added in typescript@4.9
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                throw new Error(`Failed to save flag ${feature} in session storage: `, { cause: error });
            }
        });
    }
    getFeatureFlagValue(flag) {
        const cachedFeatureFlag = this.getFeatureFlagValueFromCache(flag);
        if (!isNil(cachedFeatureFlag)) {
            return cachedFeatureFlag;
        }
        return this.getFeatureFlagValueFromStorage(flag);
    }
    clearFeatureFlagsStorage() {
        super.resetFeatureFlagsStorage();
        this.clearFeatureFlagsFromSessionStorage();
    }
    resetFeatureFlagsStorage() {
        super.resetFeatureFlagsStorage();
        this.updateCacheWithNewFeatureFlags(Array.from(this.featureFlags));
    }
    updateFeatureFlagsContext() {
        this.resetFeatureFlagsStorage();
        return Promise.resolve();
    }
    setFeatureFlags() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve();
        });
    }
    setFeaturesResponse(_featuresResponse) { }
}
